export enum ButtonType {
  ACCENT = 'accent',
  LIGHT = 'light',
  DARK = 'dark',
}
